export default __webpack_public_path__ + "static/media/onboarding3.58cb5b93.svg";